import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-brand-50 py-14 sm:py-20" aria-labelledby="testimonials-heading" data-id="element-311" data-mp="1nl2fudii5q4x">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-312" data-mp="1inafqw7pexpn">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-313" data-mp="2fcrqhpljn9y7">
          What other clinicians are saying
        </p>
        <h2 id="testimonials-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-314" data-mp="2bchiy8i3sbh8">
          Clinicians already planning with a system
        </h2>

        <div className="mt-9 grid gap-4 sm:gap-5 md:grid-cols-2" data-id="element-315" data-mp="ux6lhfgeoabb">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="flex flex-col rounded-2xl border border-navy-900/10 bg-white p-5 shadow-card sm:p-6" data-id="element-316" data-mp="px23fkzun7iz">
              <div className="flex items-center gap-0.5" aria-label="Rated 5 out of 5" data-id="element-317" data-mp="12sisohsczh7">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} aria-hidden="true" className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-318" data-mp="3ja85umdifluo" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[14.5px] leading-relaxed text-navy-900" data-id="element-319" data-mp="3e90zmrr0muq4">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-320" data-mp="30j7b6ajfacgx">
                <img src={testimonial.image} alt={`Portrait of ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} data-id="element-321" data-mp="35fxmylo72lwj" />
                <div className="min-w-0" data-id="element-322" data-mp="2cdo8h274jh15">
                  <p className="text-[14px] font-bold text-navy-900" data-id="element-323" data-mp="2cepv83xi5ryp">{testimonial.name}</p>
                  <p className="text-[12.5px] font-medium text-ink-500" data-id="element-324" data-mp="27m6fp1f98mr9">{testimonial.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="Join them for $27 today" data-id="element-325" data-mp="1xptfrlt49co2" />
      </div>
    </section>;
}